import { Component, OnInit } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import _ from "lodash";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { UtilService } from "src/app/shared/helper/util.service";
import { HomePageService } from "src/app/shared/services/homepage.service";
import { AnalyticsService } from "../analytics/analytics.service";
import { Router } from "@angular/router";
import { ManageRequestsService } from "../manage-requests/manage-requests.service";
import { MatDialog } from "@angular/material/dialog";
import { RequestAccessDialogComponent } from "src/app/shared/request-access-dialog/request-access-dialog.component";

@Component({
  selector: "app-app",
  templateUrl: "./application.component.html",
  styleUrls: ["./application.component.scss"],
})
export class ApplicationComponent implements OnInit {
  applicationsModule: any;
  applicationsModuleRecords: any = [];
  token: any;
  getApplicationsModules: any = [];
  isViewMoreVisible: boolean = false;
  getModuleDatabyId: any;
  successMessage: any;

  viewMode = "tab1";
  userId: string;
  errMsgPopup: any;
  showErrorMessageWithPopup: any = false;
  clearSubscription: Subscription;
  moduleByteMap: any;

  subscriptionMsg =
    "Please contact DMINT Administrator to get subscription of the same";
  errMsg: any;
  closeSign: string;
  isUserLoggedIn: boolean = false;
  headerId: any = 5;
  applicationModule: any = [];
  applicationsData: any = [];
  allApplicationsModulesHeaders: any;
  totalResultCount: any;
  capabilitiesModuleRecords: any[];
  sortBy: any = "order";
  sortType: any = "asc";
  currentPage: any = 1;
  allProdcuts: any[];
  stepOneDetails: any;
  companyId: any;

  constructor(
    private homePageService: HomePageService,
    private spinnerService: NgxSpinnerService,
    private utilService: UtilService,
    private analyticService: AnalyticsService,
    private auth: AuthService,
    private router: Router,
    public manageRequestService: ManageRequestsService,
    private dialog: MatDialog,
  ) {
    this.auth.getAccessTokenSilently().subscribe((res: any) => {
      localStorage.setItem("token", res);
    });
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.utilService.goToTop();
    this.utilService.getHeaderId.subscribe(
      (res: any) => (this.headerId = res || this.headerId),
    );
    this.utilService.companyId.subscribe((res: any) => (this.companyId = res));

    this.isUserLoggedIn =
      localStorage.getItem("id") != "undefined" &&
      localStorage.getItem("id") != undefined
        ? true
        : false;

    this.utilService.moduleBytes.subscribe((mod) => {
      this.moduleByteMap = mod as Object;
    });

    this.utilService.getUserId.subscribe((userId: any) => {
      this.userId = userId;

      this.isUserLoggedIn = this.utilService.isUserLoggedIn();

      // form header api call
      this.getOnHeader();
    });

    this.utilService.SharingDataPopUpMessage.subscribe((res: any) => {
      this.spinnerService.hide();
      this.errMsg = res;
    });
    this.utilService.getPopupStatus.subscribe((res: any) => {
      this.spinnerService.hide();

      if (this.errMsg !== null) {
        this.showErrorMessageWithPopup = res;
      }
    });
  }

  onSignIn() {
    this.utilService.onSignIn();
  }

  onSubscribe() {
    this.errMsg = this.subscriptionMsg;
    this.closeSign = "OK";
    this.showErrorMessageWithPopup = true;
  }

  onApplicationsApicall(moduleLink: any) {
    this.spinnerService.hide();
    window.open(`${moduleLink}`, "_blank");
  }

  onCloseHandler() {
    if (
      this.errMsgPopup != undefined &&
      this.errMsgPopup.includes("Session Expired")
    ) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(["/login"], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    }
    this.errMsg = null;
    this.showErrorMessageWithPopup = false;
  }

  getOnHeader() {
    this.homePageService.onHeader(this.userId).subscribe((res) => {
      this.spinnerService.hide();
      this.applicationModule = res;

      if (this.applicationModule.message === "OK") {
        this.applicationsData = this.applicationModule.result;
        this.capabilitiesModuleRecords = [...this.applicationsData];
        for (let modulerecord of this.capabilitiesModuleRecords) {
          if (modulerecord.headerName == "Applications") {
            this.getApplicationsModules = modulerecord.modules;
            this.totalResultCount = this.getApplicationsModules?.length;
            this.allApplicationsModulesHeaders = _.cloneDeep(
              modulerecord.modules,
            );
            this.getAllAnalyticsModules(true);
          }
        }
      }
    });
  }
  getAllAnalyticsModules(flag = false) {
    this.fetchProducts(flag);
  }
  fetchProducts(flag: any) {
    let userId = localStorage.getItem("userId");
    userId = userId == "undefined" ? null : userId;

    let payload: any = {
      userId: userId,
      headerId: this.headerId,
      searchText: null,
      categoryIds: null,
      regionIds: null,
      businessLineIds: null,
      functionIds: null,
      productLineIds: null,
      sortBy: this.sortBy,
      sortType: this.sortType,
      limit: 500,
      page: this.currentPage,
    };
    this.analyticService
      .getAllAnalyticsModules(payload, "analytics")
      .subscribe({
        next: (res: any) => {
          this.spinnerService.hide();
          this.getApplicationsModules = res.result;
          this.totalResultCount = res.totalCount;
          if (this.getApplicationsModules?.length > 0) {
            this.getApplicationsModules.forEach((ele: any) => {
              let index = this.allApplicationsModulesHeaders?.findIndex(
                (item: any) => item.id == ele.moduleId,
              );
              if (index > -1) {
                ele.subscription =
                  this.allApplicationsModulesHeaders[index]["subscription"];
                ele.moduleLink =
                  this.allApplicationsModulesHeaders[index]["moduleLink"];
              }
            });
            if (flag) {
              this.allProdcuts = [];
              this.allProdcuts = [
                ...this.allProdcuts,
                ...this.getApplicationsModules,
              ];
              this.getApplicationsModules = _.cloneDeep(this.allProdcuts);
            }
          }
        },
        error: (err) => {
          this.spinnerService.hide();
          this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.errMsg = res;
          });
          this.showErrorMessageWithPopup = true;
          setTimeout(() => {
            this.showErrorMessageWithPopup = false;
            this.errMsg = "";
          }, 5000);
        },
      });
  }

  onRequestAccessClick(module: any) {
    this.getStepOneDetails(module);
  }

  getStepOneDetails(module: any) {
    this.manageRequestService
      .getDataForSteps(module.moduleId)
      .subscribe((res: any) => {
        if (res) {
          this.stepOneDetails = res.result;
          this.callRequestPopup(module, this.stepOneDetails);
        }
      });
  }
  callRequestPopup(module: any, stepDetails: any) {
    const dialogRef = this.dialog.open(RequestAccessDialogComponent, {
      width: "800px",
      maxWidth: "90vw",
      data: {
        module: module,
        stepDetails: stepDetails,
        title: `Request access to ${module.moduleName}`,
        panelClass: "request-access-dialog",
        disableClose: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const apiPayload = {
          submittedByUserId: this.userId,
          companyId: this.companyId,
          headerId: this.headerId,
          moduleId: module?.moduleId,
          isModuleAttached: result?.isModuleAttached,
          userGroups: result?.userGroups,
        };
        this.manageRequestService.createAccessRequest(apiPayload).subscribe({
          next: (response: any) => {
            if (response.code == 200) {
              this.successMessage = response?.result;
              setTimeout(() => {
                this.successMessage = "";
              }, 5000);
              module.accessCompleted = false;
              //this.getHeader();
            }
          },
          error: (error) => {
            this.errMsg = "Failed to submit access request. Please try again.";
            this.showErrorMessageWithPopup = true;
            setTimeout(() => {
              this.errMsg = "";
              this.showErrorMessageWithPopup = false;
            }, 5000);
          },
        });
      }
    });
  }
  

  onAccessPending() {
    this.errMsg = `Please contact <a 
      href='https://outlook.office.com/mail/deeplink/compose?to=platform@dacoval.com' 
      target='_blank' 
      class='admin-email-link'>
      DMINT Administrator
    </a> to get access for the same`;
    this.closeSign = "OK";
    this.showErrorMessageWithPopup = true;
  }
}
